// extracted by mini-css-extract-plugin
export default {"gallery":"Gallery_gallery__zzPvF","section":"Gallery_section__NNNip"};